import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as ReadFullPolicyIcon } from 'assets/img/icons/read-full-policy.svg';
import AnimatedAccordion from '../AnimatedAccordion';
import Section from './components/Section';
import LimitsBox from './components/LimitsBox';
import NotCoveredBox from './components/NotCoveredBox';
import CoverageSummary from './components/CoverageSummary';
import {
  Card,
  TitleWrapper,
  Button,
  Explanation,
  StyledLink,
  CustomCardTitle,
  Overview,
  SummaryDescription,
  Chevron
} from './styled';

const Contents = ({ policyLink, isRenewal }) => {
  return (
    <>
      <Explanation>
        The information below applies to each member within your policy. As the summary
        has been simplified for easier reading, please{' '}
        <StyledLink onClick={() => window.open(policyLink, '_blank', 'noopener')}>
          read the full policy
        </StyledLink>{' '}
        for all the details or{' '}
        <StyledLink onClick={() => window.Intercom('showNewMessage')}>
          talk to our customer care team
        </StyledLink>{' '}
        who are happy to help walk you through.
      </Explanation>
      <Section heading="Policy overview" hideOverflow={false}>
        <Overview>
          <LimitsBox isRenewal={isRenewal} />
          <NotCoveredBox />
        </Overview>
      </Section>
      <Section heading="Summary of coverage">
        <SummaryDescription>
          Click on the different benefits to learn more about your coverage.
        </SummaryDescription>
        <CoverageSummary />
      </Section>
    </>
  );
};

Contents.propTypes = {
  policyLink: PropTypes.string.isRequired,
  isRenewal: PropTypes.bool
};

const WhatsIncluded = ({
  showReadFullPolicyButton,
  isAccordion,
  isRenewal,
  variant = 'light',
  policyLink,
  className
}) => {
  const [isOpen, setIsOpen] = useState(!isAccordion);

  return (
    <Card
      variant={variant}
      className={className}
      onClick={() => !isOpen && setIsOpen(true)}
      isOpen={isOpen}
    >
      <TitleWrapper>
        <CustomCardTitle>What's included?</CustomCardTitle>
        {showReadFullPolicyButton && (
          <Button onClick={() => window.open(policyLink, '_blank', 'noopener')}>
            <ReadFullPolicyIcon />
            Read full policy
          </Button>
        )}
        {isAccordion && (
          <Chevron onClick={() => isOpen && setIsOpen(false)} $isOpen={isOpen}>
            Open
          </Chevron>
        )}
      </TitleWrapper>
      {isAccordion ? (
        <AnimatedAccordion isOpen={isOpen} marginTop="16px">
          <Contents policyLink={policyLink} isRenewal={isRenewal} />
        </AnimatedAccordion>
      ) : (
        <Contents policyLink={policyLink} isRenewal={isRenewal} />
      )}
    </Card>
  );
};

WhatsIncluded.propTypes = {
  showReadFullPolicyButton: PropTypes.bool,
  isAccordion: PropTypes.bool,
  isRenewal: PropTypes.bool,
  variant: PropTypes.oneOf(['light', 'dark']),
  className: PropTypes.string,
  policyLink: PropTypes.string
};

export default WhatsIncluded;
